// Side-effect-free so callers need not load the QueryClient singleton (tests mock react-query).
export const DEFAULT_QUERY_RETRY = 1;
